import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import useMapbox from '@/composables/useMapbox'
import { CustomLayerInterface } from 'mapbox-gl'
import { computed, onBeforeUnmount, watch } from 'vue'
import { useStore } from 'vuex'
import { ADD_MAP_LAYER, REMOVE_MAP_LAYER } from '@/store/mutation-types'

type Props = {
  before?: string
  layer: CustomLayerInterface
}


export default /*@__PURE__*/_defineComponent({
  __name: 'GeojsonCustomLayer',
  props: {
    before: { default: '' },
    layer: {}
  },
  setup(__props: any) {

const { map } = useMapbox()
const store = useStore()

const props = __props

const beforeLayerId = computed(() => props.before)
const layer = computed(() => props.layer)
const mapIsLoaded = computed(() => store.state.mapIsLoaded)

function removeLayer() {
  map.removeLayer(layer.value.id)
  store.commit(REMOVE_MAP_LAYER, layer.value.id)
}
function addLayer() {
  map.addLayer(layer.value, beforeLayerId.value)
  store.commit(ADD_MAP_LAYER, layer.value.id)
}

watch(
  mapIsLoaded,
  (mapIsLoaded) => {
    if (!mapIsLoaded) return
    addLayer()
  },
  { immediate: true }
)

onBeforeUnmount(() => {
  removeLayer()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div"))
}
}

})